const AuthConstants = {
  CHANGE_THEME: 'CHANGE_THEME',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  CHECK_LOGIN_SUCCESS: 'CHECK_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGOUT: 'LOGOUT',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
  SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
  SIGN_UP_DISABLE: 'SIGN_UP_DISABLE',
  REDIRECT_SCREEN: 'REDIRECT_SCREEN',
  USER_EXCEEDED : 'USER_EXCEEDED',
  CLEAR_USER_EXCEEDED : 'CLEAR_USER_EXCEEDED',

};

export default AuthConstants;